import { DeleteBucketIcon } from '@/assets/static/icons/delete-bucket';
import ModalWrappedContent from '@/components/basicComponents/modal/modalWrappedContent';
import { SORT_ORDER } from '@/components/table/types';
import { themeVar } from '@/styles/theme';
import { useMutation } from '@apollo/client';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { DELETE_DUE_DILIGENCE_FUNNEL_MUTATION, DUE_DILIGENCE_FUNNEL_LIST_SETTINGS_QUERY } from '../queries';

interface DeleteDraftProps {
  onClose: () => void;
  closeAll: () => void;
  isOpen: boolean;
}

const DeleteDraft = ({ onClose, isOpen, closeAll }: DeleteDraftProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const [deleteDueDiligenceFunnel] = useMutation(DELETE_DUE_DILIGENCE_FUNNEL_MUTATION, {
    refetchQueries: () => [
      {
        query: DUE_DILIGENCE_FUNNEL_LIST_SETTINGS_QUERY,
        variables: {
          data: {
            statusFilter: ['PUBLISHED', 'DRAFT_WITHOUT_PUBLISHED'],
            sortDirection: SORT_ORDER.ASC,
            sortBy: 'ORDER'
          },
          archivedFunnelData: {
            sortDirection: SORT_ORDER.ASC,
            sortBy: 'ORDER'
          }
        }
      }
    ]
  });

  const saveValue = () => {
    deleteDueDiligenceFunnel({
      variables: {
        id: queryParams.get('funnelId')
      },
      onCompleted: () => {
        closeAll();
      }
    });
  };

  return (
    <ModalWrappedContent isOpen={isOpen} onClose={onClose} confirmButton={{ name: 'Confirm', onClick: saveValue }}>
      <ModalContainer>
        <DeleteBucketIcon width={46} height={60} />
        <ModalTitle>Please confirm you want to delete this Draft.</ModalTitle>
        <ModalDescription>This action will delete this unpublished funnel version. This cannot be undone.</ModalDescription>
      </ModalContainer>
    </ModalWrappedContent>
  );
};

export default DeleteDraft;

const ModalContainer = styled.div`
  font-weight: 400;
  padding: 10px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

const ModalTitle = styled.div`
  font-size: 33px;
  font-weight: 400;
  text-align: center;
  color: ${themeVar('font.strong')};
`;

const ModalDescription = styled.div`
  font-size: 16px;
  line-height: 27px;
  text-align: center;
  color: ${themeVar('font.base')};
  font-weight: 400;
`;
